"use client";

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from "next/navigation";
import { ProfileActivityLogProxyActionCreated } from "@/entities/IProfile";
import { PROFILE_PROXY_ACTION_LABELS } from "@/entities/IProxy";
import CommonProfileLink from "@/components/user/utils/CommonProfileLink";
import ProfileActivityLogItemAction from "./utils/ProfileActivityLogItemAction";
import { USER_PAGE_TAB_IDS } from "@/components/user/layout/userTabs.config";
export default function ProfileActivityLogProxyAction(t0) {
  const $ = _c(14);
  const {
    log
  } = t0;
  const searchParams = useSearchParams();
  const handleOrWallet = log.target_profile_handle ?? "";
  let t1;
  if ($[0] !== searchParams) {
    t1 = (searchParams?.get("user") as string)?.toLowerCase();
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== handleOrWallet) {
    t2 = handleOrWallet.toLowerCase();
    $[2] = handleOrWallet;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isCurrentUser = t1 === t2;
  const tabTarget = USER_PAGE_TAB_IDS.PROXY;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ProfileActivityLogItemAction action="created proxy action" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = PROFILE_PROXY_ACTION_LABELS[log.contents.type];
  let t5;
  if ($[5] !== t4) {
    t5 = <span className="tw-whitespace-nowrap tw-text-base tw-font-medium tw-text-iron-200">{t4}</span>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ProfileActivityLogItemAction action="for" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== handleOrWallet || $[9] !== isCurrentUser) {
    t7 = <CommonProfileLink handleOrWallet={handleOrWallet} isCurrentUser={isCurrentUser} tabTarget={tabTarget} />;
    $[8] = handleOrWallet;
    $[9] = isCurrentUser;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t7) {
    t8 = <>{t3}{t5}{t6}{t7}</>;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}